import { Link } from "@tanstack/react-router"
import { ArrowUpRight, NotebookTabs } from "lucide-react"
import type { Scope } from "@/lib/connection"
import { useFormatNumber, useT } from "@/lib/i18n"
import type { Ontology } from "@/workspace/ontology"
import { WORKBOOK_ID } from "./data"
import { useOrderMatchCounts } from "./sync-health"

/** Business Home › Needs you: store orders the books do not agree on, one click from the review queue. */
export function OrdersNeedYou({ scope, ontology }: { scope: Scope; ontology: Ontology | undefined }) {
  const t = useT()
  const formatNumber = useFormatNumber()
  const counts = useOrderMatchCounts(scope, ontology)
  if (!counts || counts.review === 0) return null
  return (
    <Link
      to="/$orgId/$environmentId/data/workbooks/$workbookId"
      params={{ ...scope, workbookId: WORKBOOK_ID }}
      search={{ focus: "review" }}
      className="group flex items-center gap-3 rounded-2xl border border-border bg-card px-4 py-3 outline-none hover:bg-muted/40 focus-visible:ring-3 focus-visible:ring-ring/30"
    >
      <NotebookTabs className="size-4 shrink-0 text-warning" aria-hidden />
      <span className="min-w-0 flex-1">
        <span className="block text-[13px] font-medium">{t("wb.needs.title", { count: counts.review })}</span>
        <span className="block text-xs text-muted-foreground">
          {t("wb.needs.body", { missing: formatNumber(counts.missingInErp), unmatched: formatNumber(counts.unmatched) })}
        </span>
      </span>
      <span className="inline-flex items-center gap-1 text-xs text-muted-foreground group-hover:text-foreground">
        {t("wb.needs.open")} <ArrowUpRight className="size-3 rtl:-scale-x-100" aria-hidden />
      </span>
    </Link>
  )
}
